import { IPublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";
import { personnelRequest } from "../authConfig";

export class PersonnelService {

    private readonly baseUrl = process.env.REACT_APP_PERSONNEL_API_BASE_URL;

    public getMe = async (instance: IPublicClientApplication) => {
        const account = instance.getActiveAccount();
        if (!account) {
            throw new Error("No active account! Verify a user has been signed in.");
        }

        let tokenResponse;
        try {
            tokenResponse = await instance.acquireTokenSilent({
                ...personnelRequest,
                account,
            });
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect({
                    ...personnelRequest,
                    account,
                });
                return null;
            }
            throw error;
        }

        const headers = new Headers();
        headers.append("Authorization", `Bearer ${tokenResponse.accessToken}`);
        headers.append("x-functions-key", process.env.REACT_APP_PERSONNEL_FUNCTIONS_KEY || "");
        // console.log("Fetching personnel data with token:", tokenResponse.accessToken);

        //fix the url!!
        const response = await fetch(`${this.baseUrl}/api/personnel/me`, {
            method: "GET",
            headers,
        });

        if (!response.ok) {
            const errorBody = await response.text();
            throw new Error(`Request failed (${response.status}): ${errorBody}`);
        }
        // console.log("Personnel response:", response);
        return response.json();
    };
}
